export default __webpack_public_path__ + "static/media/life-insurance-banner.fcf20742.svg";